import {IntegrationAuthorization} from './IntegrationDesign';
import {integrationActions} from "../../../store/actions/integrationAction";
import {connect} from "react-redux";
import {useEffect} from "react";

function FacebookLoginRedirect({history, integration, getFacebookLoginLink, alert}) {
    useEffect(() => {
        if (integration.selectedIntegration.name === "Facebook") {
            getFacebookLoginLink();
        }
    }, [getFacebookLoginLink, integration?.selectedIntegration?.name]);

    useEffect(() => {
        if (integration?.facebook?.loginLink !== null) {
            document.location.href = integration?.facebook?.loginLink;
        }
    }, [integration?.facebook?.loginLink])

    useEffect(() => {
        if (alert.errorMsg !== "") {
            history.push({pathname: "/settings/integrations"});
        }
    }, [history, alert?.errorMsg])

    return <IntegrationAuthorization name="Facebook"/>;
}

const mapStateToProps = (state) => {
    return {
        integration: state.integration,
        alert: state.alert
    };
};

const mapDispatchToProps = {
    getFacebookLoginLink: integrationActions.getFacebookLoginLink
};

export default connect(mapStateToProps, mapDispatchToProps)(FacebookLoginRedirect);
